export const determineSavingsLevel = (savingsInfo) => {
    let level = 0;
    for (let i=0; i<savingsInfo.savingsArr.length; i++){
        if (savingsInfo.savingsArr[i].savingsClass === "bank" && level === 0){
            level = 1;
        }else{
            if (savingsInfo.savingsArr[i].savingsClass === "retirement"){
                level = 2;
            }
        }
    }
    return level;
}
export default determineSavingsLevel;